<template>
  <label class="inline-flex items-center">
    <input
      type="radio"
      class="form-radio"
      :id="`${id}-radio`"
      :data-test="`${id}-radio`"
      :name="`${id}-radio`"
      :checked="shouldBeChecked(option.value())"
      :value="option.value()"
      @change="updateInput"
    />
    <span class="ml-2 capitalize-first">
      <slot :checked="shouldBeChecked(option.value())">
        {{ option.value() }}
      </slot>
    </span>
  </label>
</template>

<script>
export default {
  name: 'MRadioItem',
  model: {
    prop: 'modelValue',
    event: 'change',
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    option: {
      type: [Object],
    },
    modelValue: {
      type: String,
      default: '',
    },
  },
  methods: {
    shouldBeChecked(option) {
      return this.modelValue === option;
    },
    updateInput(event) {
      this.$emit('change', event.target.value);
    },
  },
};
</script>

<style>
.capitalize-first:first-letter {
  @apply uppercase;
}
</style>
